import ReportsModule from './index.vue';

// eslint-disable-next-line import/prefer-default-export
export const reportRoutes = [
  {
    path: '/reports',
    component: ReportsModule,
    children: [
      {
        path: 'accounting-reports',
        name: 'AccountingReportsHome',
        component: () => import(/* webpackChunkName: "reports" */ './pages/accounting-reports-home.vue'),
        meta: {
          /** Access to this route is managed on the server no need to specify in the meta */
        },
      },
      {
        path: 'asca-reports',
        name: 'ASCAReportsHome',
        component: () => import(/* webpackChunkName: "reports" */ './pages/asca-reports-home.vue'),
        meta: {
          /** Access to this route is managed on the server no need to specify in the meta */
        },
      },
      // {
      //   path: 'invoices',
      //   name: 'Invoices',
      //   component: () => import(/* webpackChunkName: "reports" */ './pages/invoices.vue'),
      // },
      {
        path: 'transactions',
        name: 'Transactions',
        component: () => import(/* webpackChunkName: "reports" */ './pages/transactions.vue'),
        meta: {
          /** Access to this route is managed on the server no need to specify in the meta */
        },
      },
    ],
  },
];
